import type { ReactNode } from 'react';
import { ToastHost } from '@/shared/ui/feedback/toast';

interface FeedbackProviderProps {
  children: ReactNode;
}

/**
 * Provider pro globální feedback komponenty (toasty, bannery).
 * Hostuje ToastHost a případně další globální UI elementy.
 */
export function FeedbackProvider({ children }: FeedbackProviderProps) {
  return (
    <>
      {children}
      <ToastHost />
    </>
  );
}
